import { useFormContext } from "react-hook-form";
import { Tooltip } from "antd";

const MultiLineField = ({
  label,
  defaultValue = "",
  rows = 3,
  explainerText = "",
  htmlfor,
  required = false,
  readOnly = false,
  placeholder = "",
  register = null,
  rules = {}
}) => {
  const form  = useFormContext();
  register = register || form.register;
  if (!register) {
    throw new Error("No form content and no register passed");
  }
  
  const htmlFor = htmlfor ? htmlfor : label;
  return (
    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
      {required ? (
        <Tooltip title="Required field">
          <label
            htmlFor={`${htmlFor}`}
            className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
          >
            {label}<span className="text-red-500 ml-1">*</span>
          </label>
        </Tooltip>
      ) : (
        <label
          htmlFor={`${htmlFor}`}
          className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
        >
          {label}
        </label>
      )}
      <div className="mt-1 sm:mt-0 sm:col-span-2">
        <textarea

          id={`${htmlFor}`}
          name={`${htmlFor}`}
          rows={rows}
          placeholder={placeholder}
          className="max-w-lg shadow-sm block w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border border-gray-300 rounded-md"
          defaultValue={defaultValue}
          readOnly={readOnly}
          {...register(htmlFor, { required: required, ...rules })}
        />
        <p className="mt-2 text-sm text-gray-500">{explainerText}</p>
      </div>
    </div>
  );
};

export default MultiLineField;
